// extracted by mini-css-extract-plugin
export default {"thread":"Thread_thread__vkogK","thread__discussion":"Thread_thread__discussion__n9W+v","thread__title":"Thread_thread__title__BoyYb"};